import * as React from "react";
import { FaArrowDown } from "react-icons/fa";
import "../styles/styles.css";
import bg1 from "../images/bg-pau-02.jpg";
import bg2 from "../images/bg-eugeni-02.jpg";

const Landing = () => {
  const [backgroundImage, setBackgroundImage] = React.useState(bg1);

  const [style, setStyle] = React.useState({});

  React.useEffect(() => {
    const randomNum = Math.random();
    randomNum > 0.7 ? setBackgroundImage(bg2) : setBackgroundImage(bg1);
  }, []);

  React.useEffect(() => {
    setStyle({
      backgroundSize: "cover",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      backgroundImage: `url(${backgroundImage})`,
    });
  }, [backgroundImage]);

  return (
    <div
      style={{
        backgroundSize: "cover",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        backgroundImage: `url(${bg1})`,
      }}
    >
      <div className="title">
        <h1>cos paisatge</h1>
      </div>
      <div className="scrollDown">
        <a href="#header" aria-label="Anar al contingut">
          <FaArrowDown className="svgArrow" />
        </a>
      </div>
    </div>
  );
};

export default Landing;
